<template>
  <section class="photography__antiShake">
    <div
      class="photography__antiShake__videos wow textInPartMotion"
      :data-wow-duration="vm.isMobile ? '1.2s' : '.4s'"
      data-wow-delay="0.3s"
      :data-wow-offset="100"
    >
      <lazy-component v-if="!vm.isMobile" class="photography__antiShake__videos-warp">
        <video muted="muted" preload="metadata" loop="true" poster="../../assets/privacy/more-topic-1-poster.jpg">
          <source src="../../assets/privacy/more-topic-1.mp4" type="video/mp4" />
        </video>
      </lazy-component>
      <div v-else class="photography__antiShake__videos-warp">
        <img
          v-lazy="require('../../assets/photography/photography-detail-1.jpg')"
          :data-webp="require('../../assets/photography/photography-detail-1.webp')"
          alt="ColroOS 11"
        />
        <play-button class="anti-shake-paly-button" @click.native="playMobileVideo" />
      </div>
    </div>

    <div class="photography__txt text-intro">
      <div
        class="photography__txt-title wow textInPartMotion"
        :data-wow-duration="vm.isMobile ? '1.2s' : '.4s'"
        data-wow-delay="0.3s"
        :data-wow-offset="100"
      >
        <p class="title">超级防抖</p>
        <p class="sub-title">这次稳了</p>
      </div>
      <p
        v-textMotion
        class="photography__txt-content description wow textInPartMotion"
        :data-wow-duration="vm.isMobile ? '1.2s' : '.4s'"
        data-wow-delay="0.3s"
        :data-wow-offset="100"
      >
        即使在抖动、运动的情况下，依旧能拍出稳定流畅的视频大片。通过多源传感器信息融合和防抖场景智能分析，让你跑动跟拍宠物也易如反掌。
      </p>
    </div>
  </section>
</template>
<script>
import ScrollMagic from 'scrollmagic';
import Controller from '../../util/scrollMagic';
import PlayButton from '@/components/PlayButton';

export default {
  inject: ['vm'],
  components: {
    PlayButton
  },
  mounted() {
    if (!this.vm.isMobile) {
      new ScrollMagic.Scene({
        triggerElement: '.photography__antiShake__videos-warp',
        triggerHook: 1,
        offset: 100
      })
        .addTo(Controller)
        .on('enter', () => {
          console.log('video play', this.$refs);
          setTimeout(() => {
            let dom = document.querySelector('.photography__antiShake__videos-warp video');
            if (dom && (dom.paused || dom.currentTime < 1)) {
              dom.play();
            }
            dom = null;
          }, 10);
        });
    }
  },
  methods: {
    playMobileVideo() {
      console.log('handleVideoMobilePlay');
      this.vm.fullScreenVideo.open({
        src: require('../../assets/privacy/more-topic-1-mobile.mp4'),
        poster: require('../../assets/privacy/more-topic-1-poster.jpg')
      });
    }
  }
};
</script>
<style lang="scss">
.photography__antiShake {
  width: 100vw;
  padding-top: 160px;
  padding-bottom: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  &__videos {
    display: flex;
    width: 86%;
    max-width: 1050px;
    font-size: 0;
  }
}
.photography__antiShake__videos {
  .photography__antiShake__videos-warp {
    position: relative;
    width: 100%;
  }
  video {
    width: 100%;
    border-radius: 24px;
  }
  img {
    width: 100%;
    border-radius: 10px;
  }
}
.photography__txt {
  padding-top: 88px;
  width: 86%;
  max-width: 1050px;
  display: flex;
}
.photography__txt-title,
.photography__txt-content {
  width: 50%;
}
.photography__txt-title {
  .sub-title {
    font-size: 42px;
  }
}
.photography__txt.text-intro .photography__txt-content {
  padding-top: 38px;
}
@media screen and (max-width: 734px) {
  .photography__antiShake {
    flex-direction: column-reverse;
    padding-top: 0;
    height: auto;
  }
  .photography__antiShake__videos {
    width: calc(100% - 40px);
  }
  .photography__txt {
    display: block;
    width: 100%;
    box-sizing: border-box;
    padding-top: 0;
    .photography__txt-title,
    .photography__txt-content {
      width: 100%;
    }
    .photography__txt-title {
      padding-top: 0;
      .sub-title {
        font-size: 32px;
      }
    }
    .photography__txt-content {
      max-width: none;
      color: rgba(0, 0, 0, 0.5);
    }
  }
}
.anti-shake-paly-button {
  position: absolute;
  bottom: 10px;
  left: 10px;
  color: #fff;
  width: 32px;
  height: 32px;
}
</style>
